/* eslint-disable max-len */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const i18nMessages = defineMessages({
  header: {
    id: 'first-subscription-modal.header',
    defaultMessage: 'Free 1-month trial',
  },
  firstParagraph: {
    id: 'first-subscription-modal.first-paragraph-with-specified-months',
    defaultMessage: 'Congratulations - you have a {freeTrialMonths}-month free trial period!',
  },
  continue: {
    id: 'actions.continue',
    defaultMessage: 'Continue',
  },
});

const FirstSubscriptionWithFreeTrialDialog = ({ visible, freeTrialMonths, handleContinue }) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      header={formatMessage(i18nMessages.header)}
      visible={visible}
      closable={false}
      onHide={() => {}}
      style={{
        maxWidth: '25%',
      }}
    >
      <p>
        <strong>
          {formatMessage(i18nMessages.firstParagraph, {
            freeTrialMonths,
          })}
        </strong>
      </p>
      <p>
        <strong>
          <FormattedMessage
            id="first-subscription-modal.second-paragraph"
            defaultMessage="Your payment is <u>not</u> processed if you stop the subscription <u>before</u> the free trial period ends."
            values={{
              u: (text) => <u>{text}</u>,
            }}
          />
        </strong>
      </p>
      <br />
      <div className="continue-button-container">
        <Button type="button" label={formatMessage(i18nMessages.continue)} onClick={handleContinue} />
      </div>
    </Dialog>
  );
};

FirstSubscriptionWithFreeTrialDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  freeTrialMonths: PropTypes.any.isRequired,
  handleContinue: PropTypes.func.isRequired,
};

export default FirstSubscriptionWithFreeTrialDialog;
